export interface VintageStreamData {
  date: string;
  newRelease: number;
  shallow: number;
  deepCatalog: number;
  [key: string]: string | number;
}

export interface VintageStackBarData {
  date: string;
  newRelease: number;
  shallow: number;
  deepCatalog: number;
  [key: string]: string | number;
}

export interface YoYRevenueGrowthData {
  date: string;
  newRelease: number;
  shallow: number;
  deepCatalog: number;
  grandTotal: number;
  [key: string]: string | number;
}

export interface VintageTableRow {
  vintage: string;
  thisWeek: number;
  fytd: number;
  fytdChange: number;
  fytdPercent: number;
  fytdPrevPercent: number;
  shareDiff: number;
}

export const VINTAGE_COLORS = {
  newRelease: '#E74C3C', // Red (top of stack)
  shallow: '#3498DB', // Blue (middle of stack)
  deepCatalog: '#1E5AAF', // Intensive Blue (bottom of stack)
  unreconciled: '#A0A0A0', // Gray
} as const;

export const VINTAGE_LINE_COLORS = {
  newRelease: '#2ECC71', // Green
  shallow: '#00D2D3', // Cyan
  deepCatalog: '#FF9F43', // Orange
} as const;

// Colors for YoY Revenue Growth chart (matching the reference image)
export const YOY_REVENUE_COLORS = {
  newRelease: '#C0392B', // Dark Red
  shallow: '#5DADE2', // Light Blue
  deepCatalog: '#1E5AAF', // Dark Blue
  grandTotal: '#27AE60', // Green
} as const;

export const VINTAGE_LABELS = {
  newRelease: 'New Release',
  shallow: 'Shallow Catalog',
  deepCatalog: 'Deep Catalog',
  unreconciled: 'Unreconciled Data',
} as const;

export const YOY_REVENUE_LABELS = {
  newRelease: 'New Release',
  shallow: 'Shallow Catalog',
  deepCatalog: 'Deep Catalog',
  grandTotal: 'Grand Total',
} as const;

export type VintageKey = keyof typeof VINTAGE_LABELS;
